import { useEffect } from 'react';
import { tariffStore } from '@/stores/tariff.store';

export function useTariffController() {
  useEffect(() => {
    tariffStore.fetchAll();
    tariffStore.fetchArchiveDepths();
    tariffStore.fetchFormDictionaries();
  }, []);
  return tariffStore;
}
